export default {
	name: "indexView",
	data() {
		return {
			statusList: [{
				name: "全部",
				value: ""
			}, {
				name: "待付款",
				value: "0"
			}, {
				name: "已完成",
				value: "1"
			}, {
				name: "售后",
				value: "2"
			}],
			selIndex: 0,
			orderList: []
		};
	},
	watch: {},
	async mounted() {
		await this.getOrderList();
	},
	onUpdated() {},
	beforeDestroy() {},
	methods: {
		async getOrderList() {
			const listRes = await this.$zkHttp.order$getOrder({
				user_id: this.$store.state.auth.user_id,
				status: this.statusList[this.selIndex].value,
			});
			console.log("listRes ===> ", listRes);
			//状态:0=未支付,1=已付款,2=售后中,3=已售后 
			this.orderList = listRes;
		},
		async onStatusChange(index) {
			this.selIndex = parseInt(index);
			await this.getOrderList();
		},
		toMyPage(page) {
			this.$router.push(`/${page}`);
		},
		async gotoPay(e) {
			console.log("gotoPay ===> ", e);
			if (!e.id) return;
			this.$refs.cashierRef.onOpen("order", e.id);
		}
	},
};